module.exports = __webpack_public_path__ + "img/chapter-pages.81dd3374.jpg";